import { Helmet } from 'react-helmet';
import faviconUrl from '../assets/favicon-32x32.png';

export const Head = () => {
    return (
        <Helmet>
            <title>Support Hub</title>
            <link rel="shortcut icon" href={faviconUrl} />
        </Helmet>
    );
};
